// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ngw-resource-component-resource-picker-children table > tbody > tr.ant-table-row > td.ant-table-cell.actions {
  vertical-align: middle;
  padding: 2px 12px 2px 8px;
  width: 0;
}
`, "",{"version":3,"sources":["webpack://./package/nextgisweb/nextgisweb/resource/nodepkg/component/resource-picker/ResourcePickerChildren.less"],"names":[],"mappings":"AAAA;EAEQ,sBAAA;EACA,yBAAA;EACA,QAAA;AAAR","sourcesContent":[".ngw-resource-component-resource-picker-children {\n    table > tbody > tr.ant-table-row > td.ant-table-cell.actions {\n        vertical-align: middle;\n        padding: 2px 12px 2px 8px;\n        width: 0;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
